import { CSSProperties } from "react";
import LabelButton from "../Buttons/LabelButton";
import { addAlpha, Colors } from "../../utils/colors";
import { Icon } from "@iconify/react";

type ActiveInactiveLabelProps = {
  isActive: boolean;
  containerStyles?: CSSProperties;
};

// Shared Active/Inactive status pill - used across Forms, Tracking Links, DM Automations,
// Data Questions, and Products list items
const ActiveInactiveLabel = (props: ActiveInactiveLabelProps) => {
  const { isActive, containerStyles } = props;

  return (
    <LabelButton
      color={Colors.BLACK}
      backgroundColor={addAlpha(isActive ? Colors.GREEN2 : Colors.ORANGE1, 0.1)}
      borderColor={isActive ? Colors.GREEN2 : Colors.ORANGE1}
      text={isActive ? "Active" : "Inactive"}
      icon={
        isActive ? (
          <Icon
            icon="ion:ellipse"
            height={8}
            style={{ color: Colors.GREEN1 }}
          />
        ) : undefined
      }
      containerStyles={containerStyles}
    />
  );
};

export default ActiveInactiveLabel;
